import uniqWith from 'lodash/uniqWith';
import { OptionObject } from 'src/components/ReactSelectInput/ReactSelectInput.types';

const getUniqueOptions = (options: OptionObject[]) => {
  return uniqWith(options, (a, b) => a.value === b.value);
};

export { getUniqueOptions };
